"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceSize = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _useThemeContext2 = require("../hooks/useThemeContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var createMaxWidth = function createMaxWidth(value) {
  return "(max-width: ".concat(value - 1, "px)");
};
var createMinWidth = function createMinWidth(value) {
  return "(min-width: ".concat(value, "px)");
};
var DeviceSizeContext = (0, _react.createContext)(undefined);
var DeviceSizeProvider = function DeviceSizeProvider(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    deviceSize = _useState2[0],
    setDeviceSize = _useState2[1];
  var _useThemeContext = (0, _useThemeContext2.useThemeContext)(),
    mediaQueriesValues = _useThemeContext.mediaQueriesValues;
  (0, _react.useEffect)(function () {
    var mqls = {
      laptop: window.matchMedia("".concat(createMinWidth(mediaQueriesValues.m), " and ").concat(createMaxWidth(mediaQueriesValues.xl))),
      tablet: window.matchMedia("".concat(createMinWidth(mediaQueriesValues.s), " and ").concat(createMaxWidth(mediaQueriesValues.m))),
      mobile: window.matchMedia(createMaxWidth(mediaQueriesValues.s))
    };
    function checkDeviceSize() {
      if (mqls.mobile.matches) {
        setDeviceSize('mobile');
      } else if (mqls.tablet.matches) {
        setDeviceSize('tablet');
      } else if (mqls.laptop.matches) {
        setDeviceSize('laptop');
      } else {
        setDeviceSize('desktop');
      }
    }
    function mqEvent() {
      checkDeviceSize();
    }
    checkDeviceSize();
    Object.values(mqls).forEach(function (mq) {
      if (mq.addEventListener) {
        mq.addEventListener('change', mqEvent);
      } else {
        // older browsers
        mq.addListener(mqEvent);
      }
    });
    return function () {
      Object.values(mqls).forEach(function (mq) {
        if (mq.removeEventListener) {
          mq.removeEventListener('change', mqEvent);
        } else {
          // older browsers
          mq.removeListener(mqEvent);
        }
      });
    };
  }, [mediaQueriesValues.l, mediaQueriesValues.m, mediaQueriesValues.s, mediaQueriesValues.xl]);
  return /*#__PURE__*/_react["default"].createElement(DeviceSizeContext.Provider, Object.assign({
    value: deviceSize
  }, props));
};
var _default = exports["default"] = DeviceSizeProvider;
var useDeviceSize = exports.useDeviceSize = function useDeviceSize() {
  var deviceSize = (0, _react.useContext)(DeviceSizeContext);
  if (deviceSize === undefined) {
    throw new Error('useDeviceSize must be used within a DeviceSizeProvider');
  }
  return deviceSize;
};
//# sourceMappingURL=devicesize.js.map